@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

internal val Res.drawable.google_logo_dark: DrawableResource by lazy {
      DrawableResource("drawable:google_logo_dark", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/google-logo-dark.png", -1, -1),
      ))
    }

internal val Res.drawable.google_logo_light: DrawableResource by lazy {
      DrawableResource("drawable:google_logo_light", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/google-logo-light.png", -1, -1),
      ))
    }

internal val Res.drawable.preview: DrawableResource by lazy {
      DrawableResource("drawable:preview", setOf(
        ResourceItem(setOf(), "${MD}drawable/preview.png", -1, -1),
      ))
    }

internal val Res.drawable.vaisala_xweather_logo_dark: DrawableResource by lazy {
      DrawableResource("drawable:vaisala_xweather_logo_dark", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/vaisala-xweather-logo-dark.png", -1, -1),
      ))
    }

internal val Res.drawable.vaisala_xweather_logo_light: DrawableResource by lazy {
      DrawableResource("drawable:vaisala_xweather_logo_light", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/vaisala-xweather-logo-light.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_ash: DrawableResource by lazy {
      DrawableResource("drawable:weather_ash", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_ash.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_cloud: DrawableResource by lazy {
      DrawableResource("drawable:weather_cloud", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_cloud.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_drizzle: DrawableResource by lazy {
      DrawableResource("drawable:weather_drizzle", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_drizzle.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_dust: DrawableResource by lazy {
      DrawableResource("drawable:weather_dust", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_dust.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_fog: DrawableResource by lazy {
      DrawableResource("drawable:weather_fog", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_fog.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_haze: DrawableResource by lazy {
      DrawableResource("drawable:weather_haze", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_haze.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_lightning: DrawableResource by lazy {
      DrawableResource("drawable:weather_lightning", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_lightning.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_mist: DrawableResource by lazy {
      DrawableResource("drawable:weather_mist", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_mist.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_rainy: DrawableResource by lazy {
      DrawableResource("drawable:weather_rainy", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_rainy.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_sandstorm: DrawableResource by lazy {
      DrawableResource("drawable:weather_sandstorm", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_sandstorm.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_smoke: DrawableResource by lazy {
      DrawableResource("drawable:weather_smoke", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_smoke.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_snowy: DrawableResource by lazy {
      DrawableResource("drawable:weather_snowy", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_snowy.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_squall: DrawableResource by lazy {
      DrawableResource("drawable:weather_squall", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_squall.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_sunny: DrawableResource by lazy {
      DrawableResource("drawable:weather_sunny", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_sunny.png", -1, -1),
      ))
    }

internal val Res.drawable.weather_tornado: DrawableResource by lazy {
      DrawableResource("drawable:weather_tornado", setOf(
        ResourceItem(setOf(), "${MD}drawable/weather_tornado.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("google_logo_dark", Res.drawable.google_logo_dark)
  map.put("google_logo_light", Res.drawable.google_logo_light)
  map.put("preview", Res.drawable.preview)
  map.put("vaisala_xweather_logo_dark", Res.drawable.vaisala_xweather_logo_dark)
  map.put("vaisala_xweather_logo_light", Res.drawable.vaisala_xweather_logo_light)
  map.put("weather_ash", Res.drawable.weather_ash)
  map.put("weather_cloud", Res.drawable.weather_cloud)
  map.put("weather_drizzle", Res.drawable.weather_drizzle)
  map.put("weather_dust", Res.drawable.weather_dust)
  map.put("weather_fog", Res.drawable.weather_fog)
  map.put("weather_haze", Res.drawable.weather_haze)
  map.put("weather_lightning", Res.drawable.weather_lightning)
  map.put("weather_mist", Res.drawable.weather_mist)
  map.put("weather_rainy", Res.drawable.weather_rainy)
  map.put("weather_sandstorm", Res.drawable.weather_sandstorm)
  map.put("weather_smoke", Res.drawable.weather_smoke)
  map.put("weather_snowy", Res.drawable.weather_snowy)
  map.put("weather_squall", Res.drawable.weather_squall)
  map.put("weather_sunny", Res.drawable.weather_sunny)
  map.put("weather_tornado", Res.drawable.weather_tornado)
}
